import { NgOptimizedImage } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    ViewEncapsulation
} from '@angular/core';
import { dateService } from '@netwealth/nw-utils';
import { IconComponent } from '../../../../../icon/icon.component';
import { PillComponent } from '../../../../../pill/pill.component';
import { VideoComponent } from '../../../../../umbraco-blocks/components/video-block/components/video/video.component';
import { UmbracoBlockConfiguration } from '../../../../models/umbraco-blocks.types';
import { TintDirective } from '../../../tint/tint.directive';
import { MEDIA_ARTICLE_CATEGORY_COLORS } from '../../constants/media-article-category-colors.constants';

@Component({
    selector: 'nw-media-article-card',
    imports: [
        PillComponent,
        IconComponent,
        TintDirective,
        NgOptimizedImage,
        VideoComponent
    ],
    templateUrl: './media-article-card.component.html',
    styleUrl: './media-article-card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class MediaArticleCardComponent implements OnChanges {
    @Input() title!: string;
    @Input() videoUrl?: string;
    @Input() clickableUrl?: string;

    @Input() category?: string;
    @Input() date?: string;
    @Input() author?: string;
    @Input() avatar?: string;
    @Input() image?: string;
    @Input() imageTint?: UmbracoBlockConfiguration.Tint;
    @Input() duration?: string;
    @Input() article?: boolean;
    @Input() thumbnail?: string;
    @Input() videoAltText?: string;

    public publishedDate?: string;
    public id: string = this.generateUniqueId();

    public get showIcon(): boolean {
        return !!this.article || !!this.videoUrl;
    }

    public get categoryColor(): string | undefined {
        return this.category ? MEDIA_ARTICLE_CATEGORY_COLORS[this.category] : undefined;
    }

    public get isClickable(): boolean {
        return !!this.clickableUrl;
    }

    private tint?: UmbracoBlockConfiguration.Tint;

    public ngOnChanges({ date, imageTint }: SimpleChanges): void {
        this.publishedDate = undefined;

        if (date?.currentValue) {
            this.publishedDate = dateService(this.date, 'dd/MM/yyyy').format(
                'dd MMMM yyyy'
            );
        }
        if (imageTint?.currentValue) {
            this.tint = `${this.imageTint}` as UmbracoBlockConfiguration.Tint;
        }
    }

    public mouseEnter(): void {
        if (!this.isClickable) return;
        this.imageTint = 'none';
    }

    public mouseLeave(): void {
        if (!this.isClickable) return;
        this.imageTint = this.tint;
    }

    private generateUniqueId(length = 10): string {
        const CHARS = 'abcdefghijklmnopqrstuvwxyz';
        let result = '';
        for (let i = 0; i < length; i++) {
            result += CHARS.charAt(Math.floor(Math.random() * CHARS.length));
        }
        return result;
    }
}
